import React, { useState } from 'react';
import { testimonials } from '../data/testimonials';
import ContentPageHero from './ContentPageHero';

const formatAuthor = (author: string, age?: number) =>
  age ? `${author}, aged ${age}` : author;

const TRUNCATE_THRESHOLD = 200;

const TestimonialsGrid: React.FC = () => {
  const [expanded, setExpanded] = useState<Set<number>>(new Set());

  const toggleExpanded = (index: number) => {
    setExpanded((prev) => {
      const next = new Set(prev);
      if (next.has(index)) next.delete(index);
      else next.add(index);
      return next;
    });
  };

  return (
    <>
      <ContentPageHero
        title="What Our Clients Say"
        description="Real stories from high-performing individuals who reclaimed their health through expert exercise physiology."
      />
      <section className="testimonials testimonials-page">
        <div className="container">
          <div className="testimonials-page-grid">
            {testimonials.map((testimonial, index) => {
              const isLong = testimonial.quote.length > TRUNCATE_THRESHOLD;
              const isExpanded = expanded.has(index);
              const showToggle = isLong;

              return (
                <blockquote
                  key={index}
                  className={`testimonial-card ${showToggle ? 'testimonial-card--expandable' : ''} ${showToggle && isExpanded ? 'testimonial-card--expanded' : ''}`}
                >
                  <p>"{testimonial.quote}"</p>
                  {showToggle && (
                    <button
                      type="button"
                      className="testimonial-card-toggle"
                      onClick={() => toggleExpanded(index)}
                    >
                      {isExpanded ? 'See less' : 'See more'}
                    </button>
                  )}
                  <cite>— {formatAuthor(testimonial.author, testimonial.age)}</cite>
                </blockquote>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default TestimonialsGrid;
